/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useCallback, memo, useEffect, useRef, useLayoutEffect} from 'react';
import {
  TableDefault,
  TableAverage,
  ShadowTableColumn,
  ShadowTableHead,
  ShadowSummaryColumn,
  SortPopUp,
  ArrowUp,
  RadiosContainer,
  CheckBoxWrapper,
  PopUpText,
  StickyMainHeader,
  StickySubHeader,
  ChangeContainer,
  ArrowDownContainer,
  ColumnContainerSummary,
  DownloadButton,
  ReportTableColumn,
  StickyShadowMainHeader,
  LoadSpace,
  FeatureLocked,
  TitleFeatureLocked,
  TextFeatureLocked,
} from './styles';
import {Radio, InputCheckbox, SelectPlayerColumn} from '..';
import Utils, {deepGet} from '../../utils/api/Utils';
import numberColumnFormatter from '../../utils/hooks/number-column-formatter';
import getFatigueZoneBullet from '../../utils/hooks/fatigue-zone-bullet';
import {Oval} from '../../pages/players/styles';
import {GoArrowDown} from 'react-icons/go';
import HideOn from '../../assets/icons/HideOn.png';
import HideOff from '../../assets/icons/HideOff.png';
import Loader from '../loader/loader';
import {Admin} from '../../utils/api';
import getAlertZoneBullet from '../../utils/hooks/trend-zone-bullet';

function PopUp({
  table,
  useTable,
  data,
  visible,
  popup_id,
  includeAlerts,
  status,
}: {
  table: Array<any>;
  useTable: any;
  data: Array<string>;
  visible: string;
  popup_id: string;
  includeAlerts?: boolean;
  status?: Array<string>;
}) {
  const [reverse, useReverse] = useState<boolean>(true);
  const UTILS = new Utils();
  const sortOptions = [reverse, useTable, table];
  const [firstRender, useFirstRender] = useState<boolean>(true);
  const [radio, useRadio] = useState<any>({one: false, two: false});
  const [check, useCheck] = useState<any>({zone_1: false, zone_2: false, zone_3: false});

  useEffect(() => {
    if (!firstRender) {
      UTILS.HandleSorted(data, sortOptions);
    } else {
      useFirstRender(!firstRender);
    }
    if (status) buildFilter();
  }, [radio]);

  useEffect(() => {
    if (status) buildFilter();
  }, [check]);

  function buildFilter() {
    let filters: Array<string> = [];
    Object.values(check).map((item, idx) => {
      if (item) {
        filters.push(Object.keys(check)[idx]);
      }
      return item;
    });
    filters = filters.map(item => {
      if (item === 'zone_1') {
        item = 'zone 1';
      }
      if (item === 'zone_2') {
        item = 'zone 2';
      }
      if (item === 'zone_3') {
        item = 'zone 3';
      }
      return item;
    });

    useTable(
      table.filter(item => {
        let pass = false;
        const statusValue = filters.map(filterValue => {
          return deepGet(item, status) === filterValue;
        });
        statusValue.map(val => {
          if (val) {
            pass = true;
          }
          return val;
        });
        if (filters.length === 0) {
          pass = true;
        }

        return pass;
      }),
    );
  }

  function HandleRadioSort(e: any): void {
    if (e.target.id === 'descendent') {
      const descendent = {one: true, two: false};
      useReverse(false);
      useRadio(descendent);
    } else if (e.target.id === 'ascendent') {
      const ascendent = {one: false, two: true};
      useReverse(true);
      useRadio(ascendent);
    }
  }

  if (visible === popup_id) {
    return (
      <SortPopUp>
        <ArrowUp />
        <RadiosContainer onChange={HandleRadioSort}>
          <Radio title="High-Low" name="tableInfo" id="descendent" checked={false} dynamicActive={radio.one} size={'21px'} />
          <Radio title="Low-High" name="tableInfo" id="ascendent" checked={false} dynamicActive={radio.two} size={'21px'} />
        </RadiosContainer>
        {includeAlerts && (
          <>
            <hr style={{border: '0.5px solid rgba(240, 240, 240, 1)', marginBottom: '12px'}} />
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_1} onClick={() => useCheck({...check, zone_1: !check.zone_1})} />
              <PopUpText onClick={() => useCheck({...check, zone_1: !check.zone_1})}>Watch</PopUpText>
              <Oval size={'16'} color={'watch'} />
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_2} onClick={() => useCheck({...check, zone_2: !check.zone_2})} />
              <PopUpText onClick={() => useCheck({...check, zone_2: !check.zone_2})}>Warning</PopUpText>
              <Oval size={'16'} color={'warning'} />
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_3} onClick={() => useCheck({...check, zone_3: !check.zone_3})} />
              <PopUpText onClick={() => useCheck({...check, zone_3: !check.zone_3})}>Medical</PopUpText>
              <Oval size={'16'} color={'medical'} />
            </CheckBoxWrapper>
          </>
        )}
      </SortPopUp>
    );
  } else {
    return <></>;
  }
}
const TableItem = memo(({item, fatigueZone, changeStatus, hidePlayer}: any) => {
  const [hide, setHide] = useState(() => item.excludeFromExamAvg);
  const [opacity, setOpacity] = useState(() => (item.excludeFromExamAvg ? '0.5' : '1'));
  const [isLoading, setIsLoading] = useState(false);
  const PlayerRef = useRef(0) as any;
  const hiddenRef = useRef(0) as any;
  const dateRef = useRef(0) as any;
  const ADMIN = new Admin();
  /** defines where the component should start that limits the basic functionalities */
  const [left, setLeft] = useState<number>(340);

  const handleHideToggle = useCallback(async () => {
    if (!isLoading) {
      setIsLoading(true);
      const newHideState = !hide;
      setHide(newHideState);
      setOpacity(newHideState ? '0.5' : '1');
      await hidePlayer(item._id, newHideState ? 'exclude' : 'include');
      setIsLoading(false);
    }
  }, [hide, isLoading, item._id, hidePlayer]);

  async function DownloadPlayerCSV(player_id) {
    await ADMIN.GetPlayerCSV(player_id);
  }

  async function DownloadReport(examId: string, type: string, firstname: string, lastname: string, date: string) {
    if (!type) {
      type = 'Fresh';
    }
    ADMIN.GetAdminPlayersReport(examId, firstname, `${type}_` + lastname, date);
  }

  useLayoutEffect(() => {
    changeScreen();
  }, []);

  useEffect(() => {
    window.addEventListener('resize', changeScreen);

    return () => {
      window.removeEventListener('resize', changeScreen);
    };
  }, []);

  const changeScreen = () => {
    /** 19px is added to maintain component margin */
    setLeft(hiddenRef.current.offsetWidth + PlayerRef.current.offsetWidth + dateRef.current.offsetWidth + 19);
  };

  return (
    <tr style={{opacity, position: 'relative'}}>
      <td className="white pointer" onClick={handleHideToggle} ref={hiddenRef}>
        {isLoading ? (
          <Loader height="20px" width="20px" />
        ) : hide ? (
          <img src={HideOn} alt="hideOn" />
        ) : (
          <img src={HideOff} alt="hideOff" />
        )}
      </td>
      <SelectPlayerColumn PlayerColumnRef={PlayerRef} unClickeable={item.plan === 'basic'} player={item} padding={'8px'} />
      <ShadowTableColumn ref={dateRef}>
        {(item.summary.createdAt && new Date(item.summary.createdAt).toLocaleDateString('en-US')) || '-'}
      </ShadowTableColumn>
      <td className="white" style={{position: 'relative'}}>
        {item.plan !== 'basic' && numberColumnFormatter(item.summary.strgTotalLast)}
        {item.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item.summary.strgTotalStrengthStatus)}
        {item.plan !== 'basic' &&
          getAlertZoneBullet(item.summary, item.summary.strgTotalStrengthStatusTrend, item.summary.strgTotalStrengthStatus)}
      </td>
      <td className="white">{item.plan !== 'basic' && numberColumnFormatter(item.summary?.strgTotalStrengthAvg)}</td>
      <td className="white">
        <ChangeContainer>
          <span>{item.plan !== 'basic' && numberColumnFormatter(item.summary?.strgTotalStrengthChange)}</span>
          {item.plan !== 'basic' && changeStatus(item.summary.strgTotalStrengthChange)}
        </ChangeContainer>
      </td>
      <ShadowTableColumn>
        {item.plan !== 'basic' && numberColumnFormatter(item.summary.strgInternalRotationLast)}
        {item.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item.summary.strgInternalRotationStatus)}
        {item.plan !== 'basic' &&
          getAlertZoneBullet(item.summary, item.summary.strgInternalRotationStatusTrend, item.summary.strgInternalRotationStatus)}
      </ShadowTableColumn>
      <ShadowTableColumn>{item.plan !== 'basic' && numberColumnFormatter(item.summary.strgInternalRotationAvg)}</ShadowTableColumn>
      <ShadowTableColumn>
        <ChangeContainer>
          <span>{item.plan !== 'basic' && numberColumnFormatter(item.summary.internalRotationTrend)}</span>
          {item.plan !== 'basic' && changeStatus(item.summary.internalRotationTrend)}
        </ChangeContainer>
      </ShadowTableColumn>
      <td className="white" style={{position: 'relative'}}>
        {item.plan !== 'basic' && numberColumnFormatter(item.summary.strgExternalRotationLast)}
        {item.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item.summary.strgExternalRotationStatus)}
        {item.plan !== 'basic' &&
          getAlertZoneBullet(item.summary, item.summary.strgExternalRotationStatusTrend, item.summary.strgExternalRotationStatus)}
      </td>
      <td className="white">{item.plan !== 'basic' && numberColumnFormatter(item.summary.strgExternalRotationAvg)}</td>
      <td className="white">
        <ChangeContainer>
          <span>{item.plan !== 'basic' && numberColumnFormatter(item.summary.externalRotationTrend)}</span>
          {item.plan !== 'basic' && changeStatus(item.summary.externalRotationTrend)}
        </ChangeContainer>
      </td>
      <ShadowTableColumn>
        {item.plan !== 'basic' && numberColumnFormatter(item.summary.strgArmERIRLast, {digits: 2})}
        {item.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item.summary.strgERIRRatioStatus)}
      </ShadowTableColumn>
      <ShadowTableColumn>{item.plan !== 'basic' && numberColumnFormatter(item.summary.strgERIRRatioAvg, {digits: 2})}</ShadowTableColumn>
      <ShadowTableColumn>
        <ChangeContainer>
          <span>{item.plan !== 'basic' && numberColumnFormatter(item.summary.irERRatioTrend, {digits: 2})}</span>
          {item.plan !== 'basic' && changeStatus(item.summary.irERRatioTrend)}
        </ChangeContainer>
      </ShadowTableColumn>
      <td className="white" style={{position: 'relative'}}>
        {item.plan !== 'basic' && numberColumnFormatter(item.summary.strgScaptionLast)}
        {item.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item.summary.strgScaptionStatus)}
        {item.plan !== 'basic' && getAlertZoneBullet(item.summary, item.summary.strgScaptionStatusTrend, item.summary.strgScaptionStatus)}
      </td>
      <td className="white">{item.plan !== 'basic' && numberColumnFormatter(item.summary.strgScaptionAvg)}</td>
      <td className="white">
        <ChangeContainer>
          <span> {item.plan !== 'basic' && numberColumnFormatter(item.summary.scaptionTrend)}</span>
          {item.plan !== 'basic' && changeStatus(item.summary.scaptionTrend)}
        </ChangeContainer>
      </td>
      <ShadowTableColumn>
        {item.plan !== 'basic' && numberColumnFormatter(item.summary.gripLast)}
        {item.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item.summary.gripStatus)}
        {item.plan !== 'basic' && getAlertZoneBullet(item.summary, item.summary.gripStatusTrend, item.summary.gripStatus)}
      </ShadowTableColumn>
      <ShadowTableColumn>{item.plan !== 'basic' && numberColumnFormatter(item.summary.gripAverage)}</ShadowTableColumn>
      <ShadowTableColumn>
        <ChangeContainer>
          <span>{item.plan !== 'basic' && numberColumnFormatter(item.summary.gripTrend)}</span>
          {item.plan !== 'basic' && changeStatus(item.summary.gripTrend)}
        </ChangeContainer>
      </ShadowTableColumn>
      <ReportTableColumn>
        {item.plan !== 'basic' && (
          <DownloadButton type="XLSX" onClick={() => !hide && DownloadPlayerCSV(item?._id)}>
            ↓ XLSX
          </DownloadButton>
        )}

        {item.plan !== 'basic' && item?.enabledPDF && (
          <DownloadButton
            type="PDF"
            onClick={() =>
              !hide &&
              DownloadReport(item?.summary?.examId, item?.summary?.type, item?.firstName, item?.lastName, item?.summary?.createdAt)
            }>
            ↓ PDF
          </DownloadButton>
        )}
      </ReportTableColumn>
      {item.plan === 'basic' && (
        <FeatureLocked left={left} right={19}>
          <TitleFeatureLocked>
            Basic Subscription
            <TextFeatureLocked>
              {' '}
              - Unlock this data by sponsoring the athlete or have the player purchase a premium subscription
            </TextFeatureLocked>
          </TitleFeatureLocked>
        </FeatureLocked>
      )}
    </tr>
  );
});

const TableFreshStrength = memo(
  ({
    dataTableContent,
    dataAverage,
    filter,
    dataCy,
    minWidth,
    fatigueZone,
    hidePlayer,
    sortBy,
    sortOrder,
    handleSort,
  }: {
    dataTableContent: Array<any>;
    dataAverage: object | any;
    filter: string;
    dataCy?: string;
    minWidth?: string;
    team?: string;
    fatigueZone?: boolean;
    hidePlayer?: any;
    sortBy: string;
    sortOrder: string;
    handleSort: any;
  }) => {
    const [popUp, setPopUp] = useState<string>('');
    const [table, useTable] = useState<Array<any>>(dataTableContent);
    const [loading, useLoading] = useState<boolean>(false);

    useEffect(() => {
      useLoading(false);
    }, [dataTableContent]);

    const togglePopUp = useCallback((selectedPopUp: string) => {
      setPopUp(prev => (prev === selectedPopUp ? '' : selectedPopUp));
    }, []);

    const changeStatus = useCallback(change => {
      // Downward arrows hidden per requirements - logic preserved
      // if (Math.trunc(change) < 0) {
      //   return (
      //     <ArrowDownContainer>
      //       <GoArrowDown size="10px" color="#fff" />
      //     </ArrowDownContainer>
      //   );
      // }
      return null;
    }, []);

    const memoizedHidePlayer = useCallback(hidePlayer, [hidePlayer]);

    function changeTable(e) {
      useTable([...e]);
    }

    return (
      <TableDefault data-cy={dataCy} minWidth={minWidth}>
        <thead>
          <tr>
            <StickyMainHeader>HIDE</StickyMainHeader>
            <StickyMainHeader onClick={() => handleSort('playerName')} style={{cursor: 'pointer'}}>
              PLAYERS {sortBy === 'playerName' && (sortOrder === 'asc' ? '▲' : '▼')}
            </StickyMainHeader>
            <StickyShadowMainHeader onClick={() => handleSort('date')} style={{cursor: 'pointer'}}>
              DATE {sortBy === 'date' && (sortOrder === 'asc' ? '▲' : '▼')}
            </StickyShadowMainHeader>
            <StickyMainHeader colSpan={3}>TOTAL STRENGTH</StickyMainHeader>
            <StickyShadowMainHeader colSpan={3}>INTERNAL ROTATION</StickyShadowMainHeader>
            <StickyMainHeader colSpan={3}>EXTERNAL ROTATION</StickyMainHeader>
            <StickyShadowMainHeader colSpan={3}>ER : IR RATIO</StickyShadowMainHeader>
            <StickyMainHeader colSpan={3}>SCAPTION</StickyMainHeader>
            <StickyShadowMainHeader colSpan={3}>GRIP</StickyShadowMainHeader>
            <StickyMainHeader>REPORT</StickyMainHeader>
          </tr>
          <tr>
            <StickySubHeader />
            <StickySubHeader onClick={() => togglePopUp('playerName')}>
              <ColumnContainerSummary>
                <span>Name</span>
              </ColumnContainerSummary>
            </StickySubHeader>
            <ShadowTableHead onClick={() => togglePopUp('date')}>
              <ColumnContainerSummary>
                <span>Sort</span>
              </ColumnContainerSummary>
            </ShadowTableHead>
            <StickySubHeader>
              <span onClick={() => togglePopUp('pu_1')}>Result</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'strgTotalLast']}
                popup_id={'pu_1'}
                visible={popUp}
              />
            </StickySubHeader>
            <StickySubHeader>
              <span onClick={() => togglePopUp('pu_2')}>Avg</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'strgTotalStrengthAvg']}
                popup_id={'pu_2'}
                visible={popUp}
              />
            </StickySubHeader>
            <StickySubHeader>
              <span onClick={() => togglePopUp('pu_3')}>Change</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'strgTotalStrengthChange']}
                popup_id={'pu_3'}
                visible={popUp}
              />
            </StickySubHeader>
            <ShadowTableHead>
              <span onClick={() => togglePopUp('pu_4')}>Result</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'strgInternalRotationLast']}
                popup_id={'pu_4'}
                visible={popUp}
              />
            </ShadowTableHead>
            <ShadowTableHead>
              <span onClick={() => togglePopUp('pu_5')}>Avg</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'strgInternalRotationAvg']}
                popup_id={'pu_5'}
                visible={popUp}
              />
            </ShadowTableHead>
            <ShadowTableHead>
              <span onClick={() => togglePopUp('pu_6')}>Change</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'internalRotationTrend']}
                popup_id={'pu_6'}
                visible={popUp}
              />
            </ShadowTableHead>
            <StickySubHeader>
              <span onClick={() => togglePopUp('pu_7')}>Result</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'strgExternalRotationLast']}
                popup_id={'pu_7'}
                visible={popUp}
              />
            </StickySubHeader>
            <StickySubHeader>
              <span onClick={() => togglePopUp('pu_8')}>Avg</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'strgExternalRotationAvg']}
                popup_id={'pu_8'}
                visible={popUp}
              />
            </StickySubHeader>
            <StickySubHeader>
              <span onClick={() => togglePopUp('pu_9')}>Change</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'externalRotationTrend']}
                popup_id={'pu_9'}
                visible={popUp}
              />
            </StickySubHeader>
            <ShadowTableHead>
              <span onClick={() => togglePopUp('pu_10')}>Result</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'strgArmERIRLast']}
                popup_id={'pu_10'}
                visible={popUp}
              />
            </ShadowTableHead>
            <ShadowTableHead>
              <span onClick={() => togglePopUp('pu_11')}>Avg</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'strgERIRRatioAvg']}
                popup_id={'pu_11'}
                visible={popUp}
              />
            </ShadowTableHead>
            <ShadowTableHead>
              <span onClick={() => togglePopUp('pu_12')}>Change</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'irERRatioTrend']}
                popup_id={'pu_12'}
                visible={popUp}
              />
            </ShadowTableHead>
            <StickySubHeader>
              <span onClick={() => togglePopUp('pu_13')}>Result</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'strgScaptionLast']}
                popup_id={'pu_13'}
                visible={popUp}
              />
            </StickySubHeader>
            <StickySubHeader>
              <span onClick={() => togglePopUp('pu_14')}>Avg</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'strgScaptionAvg']}
                popup_id={'pu_14'}
                visible={popUp}
              />
            </StickySubHeader>
            <StickySubHeader>
              <span onClick={() => togglePopUp('pu_15')}>Change</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'scaptionTrend']}
                popup_id={'pu_15'}
                visible={popUp}
              />
            </StickySubHeader>
            <ShadowTableHead>
              <span onClick={() => togglePopUp('pu_16')}>Result</span>
              <PopUp table={dataTableContent} useTable={changeTable} data={['summary', 'gripLast']} popup_id={'pu_16'} visible={popUp} />
            </ShadowTableHead>
            <ShadowTableHead>
              <span onClick={() => togglePopUp('pu_17')}>Avg</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['summary', 'gripAverage']}
                popup_id={'pu_17'}
                visible={popUp}
              />
            </ShadowTableHead>
            <ShadowTableHead>
              <span onClick={() => togglePopUp('pu_18')}>Change</span>
              <PopUp table={dataTableContent} useTable={changeTable} data={['summary', 'gripTrend']} popup_id={'pu_18'} visible={popUp} />
            </ShadowTableHead>
            <StickySubHeader />
          </tr>
        </thead>
        <tbody>
          {dataTableContent.length > 0 && (
            <tr className="tr-average">
              <td style={{borderLeft: '7px solid var(--PrimaryBlue)'}} />
              <td>
                <TableAverage>
                  <LoadSpace>{loading && <Loader width="20px" color="#B1D6FF" />}</LoadSpace>
                  Team Average:
                </TableAverage>
              </td>
              <ShadowSummaryColumn></ShadowSummaryColumn>
              <td>{numberColumnFormatter(dataAverage?.totalStrength)}</td>
              <td>{numberColumnFormatter(dataAverage?.totalStrengthAvg)}</td>
              <td>
                <ChangeContainer>
                  <span> {numberColumnFormatter(dataAverage?.totalStrengthTrend)}</span>
                  {changeStatus(dataAverage?.totalStrengthTrend)}
                </ChangeContainer>
              </td>
              <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.internalRotation)}</ShadowSummaryColumn>
              <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.internalRotationAvg)}</ShadowSummaryColumn>
              <ShadowSummaryColumn>
                <ChangeContainer>
                  <span> {numberColumnFormatter(dataAverage?.internalRotationTrend)}</span>
                  {changeStatus(dataAverage?.internalRotationTrend)}
                </ChangeContainer>
              </ShadowSummaryColumn>
              <td>{numberColumnFormatter(dataAverage?.externalRotation)}</td>
              <td>{numberColumnFormatter(dataAverage?.externalRotationAvg)}</td>
              <td>
                <ChangeContainer>
                  <span>{numberColumnFormatter(dataAverage?.externalRotationTrend)}</span>
                  {changeStatus(dataAverage?.externalRotationTrend)}
                </ChangeContainer>
              </td>
              <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.irERRatio, {digits: 2})}</ShadowSummaryColumn>
              <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.irERRatioAvg, {digits: 2})}</ShadowSummaryColumn>
              <ShadowSummaryColumn>
                <ChangeContainer>
                  <span> {numberColumnFormatter(dataAverage?.irERRatioTrend, {digits: 2})}</span>
                  {changeStatus(dataAverage?.irERRatioTrend)}
                </ChangeContainer>
              </ShadowSummaryColumn>
              <td>{numberColumnFormatter(dataAverage?.scaption)}</td>
              <td>{numberColumnFormatter(dataAverage?.scaptionAvg)}</td>
              <td>
                <ChangeContainer>
                  <span> {numberColumnFormatter(dataAverage?.scaptionTrend)}</span>
                  {changeStatus(dataAverage?.scaptionTrend)}
                </ChangeContainer>
              </td>
              <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.gripLast)}</ShadowSummaryColumn>
              <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.gripAverage)}</ShadowSummaryColumn>
              <ShadowSummaryColumn>
                <ChangeContainer>
                  <span> {numberColumnFormatter(dataAverage?.gripTrend)}</span>
                  {changeStatus(dataAverage?.gripTrend)}
                </ChangeContainer>
              </ShadowSummaryColumn>
              <td></td>
            </tr>
          )}

          {dataTableContent.length > 0 ? (
            dataTableContent
              .filter(el => {
                const playerName: string = el?.firstName || '';
                const playerLast: string = el?.lastName || '';
                const name = `${playerName} ${playerLast}`;
                return name.toLocaleLowerCase().includes(filter.toLowerCase());
              })
              .map((item, index) => (
                <TableItem
                  key={item._id}
                  item={item}
                  fatigueZone={fatigueZone}
                  changeStatus={changeStatus}
                  hidePlayer={memoizedHidePlayer}
                />
              ))
          ) : (
            <tr>
              <td colSpan={25}>No Data</td>
            </tr>
          )}
        </tbody>
      </TableDefault>
    );
  },
);

export default TableFreshStrength;
